/* eslint-disable */

import { normalize } from "polished";
import { createGlobalStyle } from "styled-components";
import theme from "./theme";
import typography from "./typography";

const BaseStyle = createGlobalStyle`
  ${normalize()}

  html {
    font-size: 16px;
  }

  body {
    background: #0E1124;
  }

  *:not(body, html) {
    ${typography.UIText} 
    transition: all ${theme.transitionTime.quick};
    line-height: ${theme.typography.paragraphLineHeight};
  }
  *{
    -ms-overflow-style: none;
  }
  :not(.visible-scrollbar)::-webkit-scrollbar {
    display: none;
  }
  .visible-scrollbar::-webkit-scrollbar {
    display: block;
    width: 10px;
    height: 10px;
    background-color: transparent;
    -webkit-overflow-scrolling: auto
  }
  .visible-scrollbar::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }
  .visible-scrollbar::-webkit-scrollbar-corner {
    background-color: transparent;
  }
  .visible-scrollbar::-webkit-scrollbar-thumb {
    background-color: #a63638;
    border-radius: 5px;
  }

 /* Firefox-specific scrollbar styles */
@supports (-moz-appearance: none) {
    .visible-scrollbar {
        overflow: auto; /* Keeps scrollbar always visible */
        scrollbar-width: auto; /* Applies thin scrollbar width in Firefox */
        scrollbar-color: #a63638 rgba(0, 0, 0, 0.3); /* Thumb and track colors in Firefox */
    }
}

  h1 { ${typography.heading1} }
  h2 { ${typography.heading2} }
  h3 { ${typography.heading3} }
  h4 { ${typography.heading4} }
  h5 { ${typography.heading5} }
  h6 { ${typography.heading6} }

  p, p * { ${typography.paragraph} }

  h1, h2, h3, h4, h5, h6, p {
    margin-bottom: ${theme.spacing.x2};
    margin-top: ${theme.spacing.x2};

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: ${theme.color.secondaryDark};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  // accessibility options
  *:focus-visible{
    outline: 2px #000 solid;
    outline-style: auto;
  }

  // react modal
  .ReactModal__Overlay {
    opacity: 0;
    transition: all 300ms ease-in-out;
  }
  .custom-container {
    .react-select__control {
      background: #39475f;
    }
  }
  .ReactModal__Content {
    opacity: 0;
    transform: translateX(100px);
    transition: all 300ms ease-in-out;
  }

  .ReactModal__Overlay--after-open {
    opacity: 1;
  }

  .ReactModal__Overlay--before-close {
    opacity: 0;
  }
  
  .ReactModal__Content--after-open {
    opacity: 1;
    transform: translateX(0px);
  }

  .ReactModal__Content--before-close {
    opacity: 0;
    transform: translateX(100px);
  }
  .nice-dates-day:before {
    background: linear-gradient(90deg, rgb(176, 52, 52) 0%, #f00 118.29%);
    z-index: 1;
  }
  .nice-dates-navigation {
    color: #ffffff;
    padding:10px;
}
.nice-dates-day{
  color: #ffffff;
}
.nice-dates-day.-selected:hover {
  color: black;
}
.nice-dates-day.-highlight:before {
  background-color: unset;
}
.nice-dates-day.-disabled {
  cursor: default;
  pointer-events: none;
  color: #0c0d22;
}
.nice-dates-navigation_previous.-disabled::before, .nice-dates-navigation_next.-disabled::before {
  border-color: gray;
}
.nice-dates-navigation_previous::before, .nice-dates-navigation_next::before {
  border-right: 2px solid #fff;
  border-top: 2px solid #fff;
}
.nice-dates-popover {
  box-shadow: none;
  border: 1px solid #ddd;
  border-radius: 2px;
  max-width: 480px;
  transition: none;
}
.nice-dates-navigation_previous, .nice-dates-navigation_next {
  padding-bottom: calc(100% / 15);
}

.evaluate table {
  border: 0.1px solid #2b2b2b;
  border-spacing: 0;

}
.evaluate th, .evaluate td {
  border: 0.1px solid #2b2b2b;
  // padding: 8px; /* Optional: Add padding for better spacing */
}

.borderBottom th, .borderBottom td {
  border-bottom: 1px solid #2b2b2b;
  // padding: 8px; /* Optional: Add padding for better spacing */
}
`;

export default BaseStyle;
